<template>
 <div>Primax, sin configuración adicional</div>
</template>